import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsviewcoursesComponent } from './cmsviewcourses.component';



@NgModule({
  declarations: [CmsviewcoursesComponent],
  imports: [
    CommonModule
  ],
  exports: [CmsviewcoursesComponent]
})
export class CmsviewcoursesModule { }
